<template>
  <div class="expireSubscription" component="expireSubscription">
    <div class="expireSubscription-modal">
      <div class="expireSubscription-modal-header">
        <img src="../../assets/images/content/image.png" alt="" />
      </div>
      <div class="expireSubscription-modal-content">
        کاربر گرامی صفحه شما مسدود شده است لطفا از طریق پشتیبانی اقدام به رفع
        مسدودی کنید
      </div>
      <a class="expireSubscription-modal-button" href="https://t.me/+989354886180" target="_blank" >
      <button class="expireSubscription-modal-button-content">پشتیبانی تلگرام</button>
    </a>
    </div>
  </div>
</template>
<script>
export default {
    name:"expireSubscription"
}
</script>
<style lang="scss" scoped>
.expireSubscription{
    position: absolute;
    width: 100vw;
    height: 100vh;
    left:0;
    z-index:1000;
    background-color: #00000080;
    display: flex;
    align-items: center;
    justify-content: center;
    &-modal{
      background-color: #202020;
      display: flex;
      gap: 20px;
      flex-direction: column;
      align-items: center;
      max-width: 320px;
      width: 100%;
      max-height: 320px;
      min-height: 320px;
      border-radius: 16px;
      padding: 12px;
        &-header{
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 150px;
          img{
              position: absolute;
            top: -50px
            }
        }
        &-content{
          color: white;
        }
        &-button{
          width: 100%;
          padding: 12px;
          border: 2px solid #32CD32;
          border-radius: 10px;
          text-align: center;
          color: white;
        }
    }
}
</style>
